// src/features/criador/usePrograma.js
//
// Flag CRIADORES_ATIVO (AFILIADOS_CONFIG/PROGRAMA no backend, exposta em
// GET /afiliados/programa). Desligada, usuário comum não vê NADA novo do
// programa — nem a etapa do código no cadastro. Criador aprovado e admin veem
// sempre (é assim que o programa é testado antes de abrir).
//
// Uma leitura por sessão do app (cache em memória + sessionStorage por 10 min).

import { useEffect, useState } from "react";
import { API_BASE_URL } from "../../config/api";
import { resolverPerfilDeAcesso, modoDaAssinatura } from "../premium/perfilDeAcesso";

const CHAVE = "LV_PROGRAMA_CRIADORES";
const TTL_MS = 10 * 60 * 1000;
let emMemoria = null;
let emVoo = null;

function lerCache() {
  if (emMemoria && Date.now() - emMemoria.em < TTL_MS) return emMemoria.dados;
  try {
    const d = JSON.parse(sessionStorage.getItem(CHAVE) || "null");
    if (d && Date.now() - d.em < TTL_MS) {
      emMemoria = d;
      return d.dados;
    }
  } catch {
    /* sem storage */
  }
  return null;
}

export async function carregarPrograma() {
  const cache = lerCache();
  if (cache) return cache;
  if (!emVoo) {
    emVoo = fetch(`${API_BASE_URL}/afiliados/programa`)
      .then((r) => (r.ok ? r.json() : null))
      .then((dados) => {
        if (dados) {
          emMemoria = { em: Date.now(), dados };
          try { sessionStorage.setItem(CHAVE, JSON.stringify(emMemoria)); } catch { /* nada */ }
        }
        return dados;
      })
      .catch(() => null)
      .finally(() => { emVoo = null; });
  }
  return emVoo;
}

/** { programa, ativo, carregando } — `ativo` é a flag CRIADORES_ATIVO. */
export function usePrograma() {
  const [programa, setPrograma] = useState(() => lerCache());
  useEffect(() => {
    let vivo = true;
    if (!programa) carregarPrograma().then((d) => { if (vivo && d) setPrograma(d); });
    return () => { vivo = false; };
  }, [programa]);
  return { programa, ativo: programa?.CRIADORES_ATIVO === true, carregando: !programa };
}

/** Status que dão benefícios de criador (premium, selo, 10 scans). */
export const STATUS_COM_BENEFICIOS = ["ATIVA", "ATENCAO"];

export function ehCriador(user) {
  return STATUS_COM_BENEFICIOS.includes(user?.CRIADOR?.STATUS);
}

/**
 * Selo Premium da PRÓPRIA conta (o servidor calcula o dos outros em
 * `ehPremiumPublico`): assinatura própria ('pagante') ou Premium pago pela
 * academia ('academia'). Criador fica de fora — ele tem o selo dele.
 */
export function ehPremium(user) {
  if (!user || ehCriador(user)) return false;
  const perfil = resolverPerfilDeAcesso({
    subscriptionInfo: user?.SUBSCRIPTION_INFO || {},
    criador: user?.CRIADOR || null,
    parceiro: user?.PARCEIRO || null,
  });
  const modo = modoDaAssinatura(perfil);
  return modo === "pagante" || modo === "academia";
}
